import { BaseSubject } from '@/subjects/BaseSubject.model';
const state: {
  subjects: BaseSubject[];
  pages: { contentHeight: number; value: string[] }[];
  pageHeight: number;
} = {
  subjects: [],
  pages: [],
  pageHeight: 900,
};
const mutations = {
  initPage: (state: any) => {
    state.pages = [{ contentHeight: 796, value: [''] }];

    setTimeout(() => {
      let pageRef: any = document.querySelector('.pages .page:last-of-type');
      state.pageHeight = pageRef.offsetHeight;
      //页面内容高度
      state.pages[0].contentHeight =
        pageRef.lastElementChild.getBoundingClientRect().bottom -
        pageRef.getBoundingClientRect().top +
        22;
    }, 300);
  },

  append: (
    state: {
      subjects: BaseSubject[];
      pageHeight: number;
      pages: { contentHeight: number; value: string[]; height: number }[];
    },
    data: BaseSubject
  ) => {
    if (data) {
      // debugger;
      data.render();
      state.subjects.push(data);
      data.appendToPage(state.pages, state.pageHeight);

      console.log(state.pages);
    }
  },
};

const actions = {};

const getters = {};

export default {
  namespaced: true, //命名空间
  state,
  getters,
  actions,
  mutations,
};
interface Section {
  title: string;
  boxs: any[];
}
